import { motion } from "framer-motion";
import { PROCESS } from "../../lib/data";

export default function Process() {
    return (
        <section
            data-testid="process-section"
            id="process"
            className="relative py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="mb-16 max-w-2xl">
                    <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                        How we work
                    </div>
                    <h2 className="font-display font-light text-4xl md:text-5xl tracking-tighter leading-tight">
                        A calm, predictable{" "}
                        <span className="italic font-medium">
                            engineering process
                        </span>
                        .
                    </h2>
                </div>

                <div className="relative">
                    <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-border" />
                    <div className="space-y-10">
                        {PROCESS.map((p, i) => (
                            <motion.div
                                key={p.step}
                                initial={{ opacity: 0, x: -12 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true, margin: "-60px" }}
                                transition={{ delay: i * 0.05 }}
                                data-testid={`process-step-${i}`}
                                className="relative pl-14 md:pl-20"
                            >
                                <div className="absolute left-0 md:left-2 top-0 w-8 h-8 md:w-9 md:h-9 rounded-full bg-foreground text-background grid place-items-center text-xs font-medium">
                                    {p.step}
                                </div>
                                <h3 className="font-display text-xl md:text-2xl tracking-tight">
                                    {p.title}
                                </h3>
                                <p className="mt-2 text-muted-foreground max-w-2xl leading-relaxed">
                                    {p.desc}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
